import React, { useState } from 'react';
import { Col, Form, Modal, Row } from 'react-bootstrap';
import { sortBy } from 'lodash';

import EditEntityActionButtons from '../forms/EditEntityActionButtons';
import { ApiServiceServerless } from '../../xhr_libs';

export default function AddProjectRateCollectionModal(props) {
  const {
    show,
    onHide,
    building_id,
    utility,
    project_id,
    organization_id,
    rateCollections,
    updateList,
    showToast,
  } = props;

  const [collectionId, setCollectionId] = useState('');

  const [isSaving, setIsSaving] = useState(false);

  const clearForm = () => {
    setCollectionId('');
  };

  const handleSubmit = (e) => {
    setIsSaving(true);
    e.preventDefault();
    ApiServiceServerless.post(
      `/performance_projects/project_rate_collection/${parseInt(
        project_id
      )}/${collectionId}`,
      { building_ids: [building_id], utility: utility },
      { authorization_id: organization_id }
    )
      .then((res) => {
        updateList(res.data[0], 'rate_collections');
        onHide();
        clearForm();
        setIsSaving(false);
      })
      .catch((err) => {
        showToast('danger', 'Error', err);
        onHide();
        setIsSaving(false);
        throw err;
      });
  };

  const handleCancel = () => {
    onHide();
    clearForm();
  };

  return (
    <>
      <Modal show={show} onHide={onHide}>
        <Modal.Header closeButton style={{ height: '50px' }}>
          {'Add Project Rate Collection'}
        </Modal.Header>
        <Form
          noValidate
          onSubmit={handleSubmit}
          style={{
            textAlign: 'left',
          }}
        >
          <Modal.Body>
            <Row>
              <Col sm={12}>
                <Form.Group>
                  <Form.Label>Rate Collection </Form.Label>
                  <Form.Control
                    as='select'
                    onChange={(e) => setCollectionId(parseInt(e.target.value))}
                  >
                    <option key={'null-val'} value={''} hidden></option>
                    {rateCollections.filter(
                      (collection) => collection.utility_type === utility
                    ).length === 0 && (
                      <option key={'null-null'} value={''} disabled>
                        No available collections
                      </option>
                    )}
                    {sortBy(rateCollections, ['name'])
                      .filter(
                        (collection) => collection.utility_type === utility
                      )
                      .map((collection) => (
                        <option key={collection.id} value={collection.id}>
                          {collection.name +
                            ' (' +
                            collection.utility_type +
                            ')'}
                        </option>
                      ))}
                  </Form.Control>
                </Form.Group>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <EditEntityActionButtons
              onCancel={handleCancel}
              submitDisabled={collectionId === ''}
              submitShow={true}
              isSubmitting={isSaving}
            />
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
}
